export default Object.freeze({
    // apiBaseUrl: "http://15.206.82.38/api/v1/",
    // apiBaseUrl: "http://localhost:5000/api/v1/",
    // apiBaseUrl: "https://3yr8bxuy51.execute-api.ap-south-1.amazonaws.com/dev/api/v1/",
    //   apiBaseUrl: "https://renna-temp.lukojewel.dev/api/v1/",
    // apiBaseUrl: "https://app.zappit.software/dev/api/v1/",
    // apiBaseUrl: "https://app.zappit.software/api/v1/",
    apiBaseUrl: process.env.REACT_APP_API_URL,
    JWT_SECRET_KEY: process.env.REACT_APP_API_KEY
});
